import styles from "./AddressInput.module.scss";
import React, { ChangeEvent } from "react";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import { useTranslation } from "react-i18next";

interface IAddressInputProps {
  setFormatedAddress: (value: { value: string; isValid: boolean }) => void;
  formatedAddress: { value: string; isValid: boolean };
}

const AddressInput: React.FC<IAddressInputProps> = ({ setFormatedAddress, formatedAddress }) => {
  const { t } = useTranslation();
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  const ref = useOnclickOutside(() => {
    clearSuggestions();
  });

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setFormatedAddress({ value: formatedAddress.value, isValid: true });
    setValue(e.target.value);
  };

  const handleSelect = (value: google.maps.places.AutocompletePrediction) => () => {
    setValue(value.description, false);
    clearSuggestions();

    getGeocode({ address: value.description }).then((results) => {
      console.log(results[0]);
      setFormatedAddress({ value: results[0].formatted_address, isValid: true });
    });
  };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li className={styles.listItem} key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  return (
    <div className={`${styles.addressInput}`} ref={ref}>
      <label>{t("CityLocation")}</label>
      <div>
        <input
          type={"text"}
          className={`${styles.input} ${!formatedAddress.isValid && styles.invalid}`}
          value={value}
          onChange={handleInput}
          disabled={!ready}
          placeholder={t("SelectYourLocation")}
        />
        {status === "OK" && <ul className={styles.suggestions}>{renderSuggestions()}</ul>}
      </div>
    </div>
  );
};

export default AddressInput;
